import React from "react";
import { Link } from "react-router-dom";
import Icon from "../UI/Icon";
import { SITE } from "../../data/site";
import heroDesktop from "../../assets/hero.jpg";
import heroMobile from "../../assets/hero-mobile.jpg";

export default function Hero() {
  return (
    <div className="relative min-h-[92vh] bg-ink mt-[30px] lg:mt-[40px] flex items-center overflow-hidden">
      {/* LCP image: a real <img> so the browser can discover and prioritise it
          immediately, rather than waiting for CSS to reveal a background-image. */}
      <picture>
        <source media="(min-width: 1024px)" srcSet={heroDesktop} />
        <img
          src={heroMobile}
          alt=""
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </picture>
      <div className="absolute inset-0 bg-gradient-to-tr from-ink/90 via-ink/55 to-ink/20" />
      <div className="grain relative max-w-site mx-auto w-full px-5 sm:px-10 pt-24 pb-16">
        <div className="max-w-2xl">
          <p className="eyebrow eyebrow--light mb-6">Handcrafted &amp; built to last</p>
          <h1 className="text-white font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.03]">
            Bespoke carpentry &amp; joinery<br className="hidden sm:block" /> in Cambridge
          </h1>
          <p className="text-paper/85 text-lg leading-8 mt-6 max-w-xl">
            From bespoke fitted furniture and kitchens to decking, loft conversions and finishing
            joinery, we build timberwork that fits your Cambridge home perfectly. Reliable, tidy and
            obsessed with the details.
          </p>
          <div className="flex flex-wrap gap-4 mt-9">
            <Link to="/contact" className="btn-primary">Book a free consultation</Link>
            <Link to="/our-work" className="btn-outline-light">See our work</Link>
          </div>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3 mt-10 text-paper/80 text-sm">
            <span className="flex items-center gap-2">
              <Icon name="shield" className="w-5 h-5 text-brass" /> Fully insured
            </span>
            <span className="flex items-center gap-2">
              <Icon name="compass" className="w-5 h-5 text-brass" /> Design-led builds
            </span>
            <span className="flex items-center gap-2">
              <Icon name="quote" className="w-5 h-5 text-brass" /> Free written quotes
            </span>
            <a href={SITE.phoneHref} className="flex items-center gap-2 hover:text-brass">
              <Icon name="phone" className="w-5 h-5 text-brass" /> {SITE.phone}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
